import { TableHeaderProps } from './types';
import { TableHeader } from './TableHeader';

// Helper function to create a table header with the component
export const createTableHeader = (
  column: any,
  handleSort: (columnId: string, direction: 'asc' | 'desc') => void,
  options?: Omit<TableHeaderProps, 'column' | 'onSort'> & { icon?: React.ReactNode; customHeader?: React.ReactNode }
) => <TableHeader column={column} onSort={handleSort} {...options} customHeader={options?.customHeader} />;

export const createFilterShipmentItems = (items?: Array<{ value?: any; count?: number }>) => {
  // Handle empty or undefined input
  if (!items || !Array.isArray(items)) return [];

  return items
    .map((item) => {
      // Debug: Log the item structure to understand backend response
      console.log('Shipment filter item:', item);

      // The value can be:
      // 1. A string (simple shipment number)
      // 2. An object with { shipmentNumber, hasSpotShipment }
      // 3. An object with { value, hasSpotShipment }
      let shipmentNumber: string;
      let hasSpotShipment = false;

      if (typeof item?.value === 'object' && item?.value !== null) {
        // Value is an object
        const valueObj = item.value;
        shipmentNumber = valueObj.shipmentNumber || valueObj.value || '';
        hasSpotShipment = valueObj.hasSpotShipment === true || valueObj.hasSpotShipment === 'true';
      } else {
        // Value is a string
        shipmentNumber = String(item?.value || '');
        // Check if hasSpotShipment is at the item level
        hasSpotShipment = (item as any)?.hasSpotShipment === true || (item as any)?.hasSpotShipment === 'true';
      }

      return {
        id: shipmentNumber,
        label: shipmentNumber,
        count: item?.count || 0,
        hasSpotShipment,
      };
    })
    .filter((item) => item.id) // Remove items without shipment number
    .sort((a, b) => String(a.label).localeCompare(String(b.label)));
};
